module.exports = __webpack_public_path__ + "img/inbox.1fc170db.svg";